export default __webpack_public_path__ + "alert-icon.png?df64747ebcc31d7ddd8096db65855db3";